module.exports = __webpack_public_path__ + "media/private_club.80152571.jpg";